<template>
  <div class="com-box" v-show="show">
    <div class="comment">
      <textarea
        ref="commentinput"
        type="text"
        class="comment-input"
        :placeholder="
          replyName ? `回复  ${replyName}` : '请输入评论内容，最多输入500字'
        "
        maxlength="500"
        v-model="content"
      >
      </textarea>
      <div class="comment-btm">
        <div @click="closeInput">{{ content.length }}/500</div>
        <button
          ref="com-btn"
          class="com-sub-btn"
          :class="{ 'active-btn': content.length }"
          @click="sendComment"
        >
          发送
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { setComment } from '@/api/clockin';
import { Toast } from 'vant';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    replyId: {
      // 回复的评论ID
      type: String,
      default: '',
    },
    replyName: {
      // 回复的用户名
      type: String,
      default: '',
    },
    cardId: {
      // 回复的打卡ID
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: '',
      timer: null,
    };
  },
  watch: {
    show: {
      handler(val) {
        if (!val) {
          return;
        }

        this.$nextTick(() => {
          const ele = this.$refs.commentinput;
          ele.focus();

          // 当评论框失去焦点时，延时关闭评论框。不延时，用户点击发送按钮时，无法触发。
          const that = this;
          ele.onblur = () => {
            that.timer = setTimeout(() => {
              that.closeInput();
            }, 100);
          };
        });
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @description 发表评论
     */
    sendComment() {
      if (this.timer) {
        clearInterval(this.timer);
      }

      if (this.content.length === 0) {
        this.$refs.commentinput.focus();
        return;
      }

      const data = {
        content: this.content,
        user_punch_id: this.cardId,
      };

      if (this.replyId) {
        data.reply_id = this.replyId;
      }

      setComment(data).then((res) => {
        Toast('发表评论成功');

        this.content = '';
        res.data.isLocal = true;
        this.$emit('success', res.data);
      });
    },
    closeInput() {
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="stylus" scoped>
.com-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 998;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.comment {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding: 10px 16px;
  box-sizing: border-box;
  width: 100vw;
  height: 140px;
  background: #fff;

  .comment-input {
    width: 100%;
    height: 74px;
    font-size: 15px;
    color: #191919;
    caret-color: #FF9645;
    line-height: 20px;
    border: none;
    outline: none;
    resize: none;

    &::-webkit-input-placeholder {
      color: #dadada;
    }

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .comment-btm {
    position: absolute;
    bottom: 10px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    width: 100%;
    height: 32px;
    font-size: 14px;
    color: #dadada;
  }

  .com-sub-btn {
    width: 64px;
    height: 32px;
    background: #DADADA;
    border-radius: 16px;
    border: none;
    outline: none;
    font-size: 16px;
    color: #fff;
  }

  .active-btn {
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
  }
}
</style>
